module.exports = __webpack_public_path__ + "static/img/xinke.de1c323.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xinke.png
// module id = mWg2
// module chunks = 128